import Vue from 'vue';
import Vuex from 'vuex';
import VuexHistory from 'vuex-history';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

Vue.use(Vuex);
Vue.use(VuexHistory);

export const store = new Vuex.Store({
    state,
    actions,
    getters,
    mutations
});

const watchStateNames = ['project/pages'];
const maxHistoryLength = 5;
export const vuexHistory = new VuexHistory( store, watchStateNames, maxHistoryLength );

